/* eslint no-template-curly-in-string: "off" */
import { PAYMENT_STATUSES } from "../utils/enums";

export const defaultFaqs = {
  global: {
    default: [
      // {
      //   question: "global #1 question",
      //   answer: "global #1 answer",
      // },
      // {
      //   question: "global #2 question",
      //   answer: "global #2 answer",
      // },
    ],
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        // {
        //   question: "global pending acceptance question #1",
        //   answer: "global pending acceptance answer #1"
        // },
        // {
        //   question: "How long will it take until I receive my payment?",
        //   answer: "Generally speaking, funds are delivered electronically to the payment network you select within mere moments – typically well within a minute or two. You will receive a confirmation message once your payment is scheduled for delivery; Amazon and PayPal will also send a final confirmation once the funds are received in your account. For direct bank transfers, please consult your online banking statement for verification of receipt."
        // },
        // {
        //   question: "Am I able to receive a paper check?",
        //   answer: "No. You will be paid instantly via convenient electronic payment. Through the use of electronic payments, ${programName} eliminates the hassle and cost of paper check administration, printing, and mailing."
        // }
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        // {
        //   question: "global complete question #1",
        //   answer: "global complete answer #1"
        // },
      ]
    }
  }
};

export default defaultFaqs;
